import { render, staticRenderFns } from "./AppCopyableText.vue?vue&type=template&id=5db20617&scoped=true"
import script from "./AppCopyableText.vue?vue&type=script&lang=js"
export * from "./AppCopyableText.vue?vue&type=script&lang=js"
import style0 from "./AppCopyableText.vue?vue&type=style&index=0&id=5db20617&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db20617",
  null
  
)

export default component.exports